const state = () => ({})

const getters = {}

const actions = {
    async create(_, createCustomerDto) {
        return this.$apiV1.post(
            '/user/register',
            [
                createCustomerDto
            ]
        );
    },
    async update(_, updateCustomerDto) {
        return this.$apiV1.post(
            '/business/user/update',
            [
                updateCustomerDto
            ]
        );
    },
    async export(_, exportCustomersDto) {
        return this.$apiV1.get(
            '/business/export-users',
            {
                params: exportCustomersDto,
                responseType: 'blob'
            }
        );
    }
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}